import React, {useEffect, useState} from 'react'
import ModalEnabled from '../../../components/modalComponents/ModalEnabled';
import PageHeader from '../../../components/pageHeader/PageHeader';
import SearchContainer from '../../../components/pageComponents/SearchContainer';
import PageButtons from '../../../components/pageComponents/PageButtons';
import {useManagePostRequest} from '../../../hooks/useManagePostRequest/useManagePostRequest';
import {
    cuadroRequerimientosGetCampanasForFiltroListarCuadroSedesAPI,
    cuadroRequerimientosGetReporteCuadroRequerimientoProfesoresMasivoAPI,
    cuadroRequerimientosListarCuadroSedesAPI,
    getAllDepartamentosAPI,
    getAllEstadosAPI, getAllSedesAPI,
} from '../../../consumers/backendApisUrls';
import styled from "styled-components";
import {useGetRequest} from "../../../hooks/useGetRequest/useGetRequest";
import {
    initialAllOptionPromises, isNullOrUndefinded,
    jsonNoEstaVacio,
    updateFiltersWithExtraData
} from "../../../helper/utils";
import PageWrapper from "../../../components/pageComponents/PageWrapper";
import {useManageGetRequest} from "../../../hooks/useManageGetRequest/useManageGetRequest";
import useDidMountEffect from "../../../hooks/useDidMountEffect/useDidMountEffect";
import Select from "react-select";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import MonitorCampana from "./modales/MonitorCampana";
import { useHistory } from "react-router-dom";
import {toast} from "react-toastify";
import TableListarCuadroRequerimientos from "./TableListarCuadroRequerimientos";

const INIT_KEYS = {
    IdsSedes: "IdsSedes",
    IdsDepartamentos: "IdsDepartamentos",
    IdsEstados: "IdsEstados",
};

const CuadroRequerimientosListar = () => {
    const [formValues, setFormValues] = useState({Items: [], ExtraData: {}, filters: [], selectedFilters: {}});
    const [allFilters, setAllFilters] = useState([]);

    const [searchCriteria, setSearchCriteria] = useState("");
    const [paginator, setPaginator] = useState({CurrentPage: 1});
    const [isLoading, setIsLoading] = useState(true);

    const [modalEnabled, setModalEnabled] = useState({isEnable: false, component: React.Fragment});
    const [modalConfirmarEnabled, setModalConfirmarEnabled] = useState({isEnable: false, component: React.Fragment});

    const [executeGet] = useGetRequest();
    const [executeManagePost] = useManagePostRequest();
    const [executeManageGet] = useManageGetRequest();

    const [allCampanas, setallCampanas] = useState([]);
    const [selectedCampana, setSelectedCampana] = useState();

    const history = useHistory();

    const initialPromises = () => {
        const response = executeGet(getAllEstadosAPI());

        return [
            executeGet(getAllSedesAPI()),
            executeGet(getAllDepartamentosAPI()),
            response,
        ];
    }

    const init = async () => {
        setIsLoading(true);
        try {
            await manageSearch();
            await getAllCampanas();
            await initialAllOptionPromises(initialPromises, Object.values(INIT_KEYS), setAllFilters);
            if (formValues.filters.length === 0) {
                jsonNoEstaVacio(formValues.ExtraData) &&
                updateFiltersWithExtraData(allFilters, formValues.ExtraData, handleUpdatedFilters);
            }
            setIsLoading(false);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    }

    const manageSearch = async () => {
        setIsLoading(true);
        const api = cuadroRequerimientosListarCuadroSedesAPI();
        const payload = getPayload();
        await executeManagePost(api, payload, successManageSearchCallback);
        setIsLoading(false);
    }

    const getPayload = () => {
        return {
            Criteria: searchCriteria,
            Page: paginator.CurrentPage,
            IdCampana: selectedCampana?.value ?? 0,
            ...formValues.selectedFilters
        }
    }

    const getAllCampanas = async () => {
        const api = cuadroRequerimientosGetCampanasForFiltroListarCuadroSedesAPI();
        await executeManageGet(api, (res) => successGetAllCampanasCallback(res), false);
    }

    const successGetAllCampanasCallback = ({data}) => {
        const items = data.map(o => ({value: o.IdCampana, label: o.Nombre}));
        setallCampanas(items);

        if (items.length > 0) {
            if (isNullOrUndefinded(selectedCampana?.value)) {
                setSelectedCampana(items[0]);
            }else{
                let selected = items.find(o => o.value === selectedCampana?.value);
                setSelectedCampana(selected);
            }
        }

    }

    const descargarReporteProfesores = async () => {
        if (!selectedCampana?.value) {
            toast.error("Debe seleccionar una campaña");
            return;
        }
        setIsLoading(true);
        await executeManagePost(
            cuadroRequerimientosGetReporteCuadroRequerimientoProfesoresMasivoAPI(),
            getPayload(),
            () => {
                toast.success(
                    <div>
                        <strong>¡Solicitud enviada correctamente!</strong>
                        <p style={{margin: "4px 0 0"}}>Estamos generando tu reporte. En unos minutos recibirás un correo electrónico con el archivo solicitado. Gracias por tu paciencia.</p>
                    </div>
                );
            },
            false,
            () => { toast.error("Ocurrió un inconveniente al generar el reporte. Por favor, inténtalo nuevamente en unos minutos."); },
            false,
        );
        setIsLoading(false);
    }

    const successManageSearchCallback = ({data}) => {
        const {Items, ExtraData, TotalItems, FirsItemPage, LastItemPage, TotalPages, CurrentPage} = data;
        setFormValues(lastData => ({...lastData, Items, ExtraData}));
        setPaginator({TotalItems, FirsItemPage, LastItemPage, TotalPages, CurrentPage});
        setIsLoading(false);
    }

    const handleUpdatedFilters = (res) => {
        setFormValues(lastData => ({...lastData, filters: res}))
    }

    const handleCleanSearch = () => {
        setFormValues({...formValues, selectedFilters: null});
    }


    useDidMountEffect(() => {
        jsonNoEstaVacio(formValues.ExtraData) && updateFiltersWithExtraData(allFilters, formValues.ExtraData, handleUpdatedFilters);
    }, [formValues.ExtraData])

    useEffect(() => {
        init();
    }, [])

    useDidMountEffect(() => {
        manageSearch();
    }, [paginator.CurrentPage, formValues.selectedFilters])

    useDidMountEffect(() => {
        manageSearch();
    }, [selectedCampana?.value])

    return (

        <PageWrapper isLoading={isLoading}>
            <ModalEnabled
                modalEnabled={modalEnabled}
                setModalEnabled={setModalEnabled}
                refreshPage={manageSearch}
            />

            <ModalEnabled
                modalEnabled={modalConfirmarEnabled}
                setModalEnabled={setModalConfirmarEnabled}
                refreshPage={manageSearch}
            />

            <PageHeader title="Lista Cuadro Requerimientos"/>

            <SelectCampanas items={allCampanas} selectedItem={selectedCampana} setSelectedItem={setSelectedCampana}/>

            <SearchContainer
                searchCriteria={searchCriteria}
                setSearchCriteria={setSearchCriteria}
                setPaginator={setPaginator}
                manageSearch={manageSearch}
                addCleanSearch={handleCleanSearch}>
                <ButtonsWrapper>
                    <div className="d-flex">
                        <PageButtons>
                            <button
                                type="button"
                                className="generic-button-buscador"
                                onClick={descargarReporteProfesores}
                            >
                                Descarga reporte profesores
                            </button>

                            {formValues.ExtraData.PuedeAbrirMonitorCampana === true &&
                            <button
                                type="button"
                                className="generic-button-buscador"
                                onClick={() =>
                                   {
                                       if ( isNullOrUndefinded(selectedCampana?.value) ) {
                                           toast.error("Seleccionar Campaña")
                                           return
                                       }

                                       setModalEnabled({
                                           isEnable: true,
                                           component: MonitorCampana,
                                           data: {idCampana : selectedCampana?.value, getAllCampanas: getAllCampanas, manageSearch: manageSearch, setModalConfirmarEnabled}
                                       })
                                   }
                                }
                            >
                                Monitor Proceso
                            </button>
                            }

                            {formValues.ExtraData.PuedeConfigurarCampanas === true &&
                            <span
                                className="d-inline-flex align-items-center justify-content-center ml-2 hand-pointer"
                                style={{
                                    width: '32px',
                                    height: '32px',
                                    backgroundColor: 'gray',
                                    borderRadius: '50%'
                                }}
                                onClick={() => history.push("/cuadroRequerimientosCampanas")}
                            >
                              <FontAwesomeIcon
                                  icon="cog"
                                  style={{
                                      color: 'white',
                                      fontSize: '18px'

                                  }}
                                  title="Configurar"
                              />
                            </span>
                            }

                        </PageButtons>

                    </div>

                </ButtonsWrapper>
            </SearchContainer>


            <TableListarCuadroRequerimientos
                formValues={formValues}
                setFormValues={setFormValues}
                extraData={formValues.ExtraData}
                setModalEnabled={setModalEnabled}
                paginator={paginator}
                setPaginator={setPaginator}
                keys={INIT_KEYS}
                manageSearch={manageSearch}
                fromAdminPage={true}
            />



        </PageWrapper>

    );
};

export default CuadroRequerimientosListar;

const SelectCampanas = ({items, selectedItem, setSelectedItem}) => (
    <div className='col-sm-4 mt-2 ml-2'>
        <Select
            placeholder="Seleccionar Campaña"
            options={items}
            value={selectedItem}
            onChange={(res) => setSelectedItem({...res})}
        />
    </div>
)

const ButtonsWrapper = styled.div`
    display: block;
    @media (max-width: 796px) {
        display: none;
    }
`;
